import axios from 'axios'
import qs from 'qs'
axios.defaults.timeout = 60000

// 创建一个axios实例
const service = axios.create({
  // 请求超时时间
  timeout: 60000,
})

// 添加请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  err => {
    console.log(err)
  }
)

service.interceptors.response.use(
  response => {
    let res = {}
    res.status = response.status
    res.data = response.data
    return res
  },
  err => console.log(err)
)

export function ajaxForm(url, data = {}) {
  var headers = null
  var successFunc = null
  var failureFunc = null
  if (arguments.length > 2) {
    if (arguments[2] instanceof Function) {
      successFunc = arguments[2]
    } else if (arguments[2] instanceof Object) {
      headers = arguments[2]
    }
  }
  if (arguments.length > 3 && arguments[3] instanceof Function) {
    if (successFunc) {
      failureFunc = arguments[3]
    } else {
      successFunc = arguments[3]
    }
  }
  if (arguments.length > 4 && arguments[4] instanceof Function) {
    failureFunc = arguments[4]
  }
  if (!headers) {
    headers = {}
  }
  var authorization = sessionStorage.getItem('access_token')
  if (authorization) {
    headers['Authorization'] = authorization
  }
  var params = null
  if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    params = qs.stringify(data)
  } else {
    params = data
  }
  service
    .post(url, params, {
      headers: headers,
    })
    .then(response => {
      if (successFunc) {
        successFunc(response['data'])
      } else {
        if (failureFunc) {
          failureFunc()
        }
      }
    })
}

export function ajaxJson(url, data = {}) {
  var headers = null
  var successFunc = null
  var failureFunc = null
  if (arguments.length > 2) {
    if (arguments[2] instanceof Function) {
      successFunc = arguments[2]
    } else if (arguments[2] instanceof Object) {
      headers = arguments[2]
    }
  }
  if (arguments.length > 3 && arguments[3] instanceof Function) {
    if (successFunc) {
      failureFunc = arguments[3]
    } else {
      successFunc = arguments[3]
    }
  }
  if (arguments.length > 4 && arguments[4] instanceof Function) {
    failureFunc = arguments[4]
  }
  if (!headers) {
    headers = {}
  }
  var authorization = sessionStorage.getItem('access_token')
  if (authorization) {
    headers['Authorization'] = authorization
  }
  var params = null
  if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    params = qs.stringify(data)
  } else {
    params = data
  }
  service
    .post(url, params, {
      headers: headers,
    })
    .then(response => {
      if (successFunc) {
        successFunc(response['data'])
      } else {
        if (failureFunc) {
          failureFunc()
        }
      }
    })
}

function ajaxUpload(url, file, data = {}) {
  var headers = null
  var successFunc = null
  var failureFunc = null
  if (arguments.length > 2) {
    if (arguments[2] instanceof Function) {
      successFunc = arguments[2]
    } else if (arguments[2] instanceof Object) {
      headers = arguments[2]
    }
  }
  if (arguments.length > 3 && arguments[3] instanceof Function) {
    if (successFunc) {
      failureFunc = arguments[3]
    } else {
      successFunc = arguments[3]
    }
  }
  if (arguments.length > 4 && arguments[4] instanceof Function) {
    failureFunc = arguments[4]
  }
  if (!headers) {
    headers = {}
  }
  headers['Content-Type'] = 'multipart/form-data'
  var authorization = sessionStorage.getItem('access_token')
  if (authorization) {
    headers['Authorization'] = authorization
  }
  var params = new FormData()
  params.append('file', file.file)
  for (var key in data) {
    params.append(key, data[key])
  }
  service
    .post(url, params, {
      headers: headers,
    })
    .then(response => {
      if (successFunc) {
        successFunc(response['data'])
      } else {
        if (failureFunc) {
          failureFunc()
        }
      }
    })
}
function getUrl(arg0, defaultValue) {
  if (arg0 && typeof arg0 === 'string' && arg0.indexOf('/') == 0) {
    return arg0
  } else {
    return defaultValue
  }
}
function getEntity(arg0) {
  if (arg0 && typeof arg0 === 'string' && arg0.indexOf('/') == -1) {
    return arg0
  }
}
function getParams() {
  for(var i=0;i<arguments.length;i++) {
    if(arguments[i] instanceof Object && !(arguments[i] instanceof Array)){
      return arguments[i]
    }
  }
}
function getFields() {
  var params = arguments[0]
  for(var i=1;i<arguments.length;i++) {
    if(params!=arguments[i]){
      if((arguments[i]) instanceof Object) {
        if(arguments[i] instanceof Array){
          return arguments[i]
        } else {
          var ret = []
          for(var key in arguments[i]){
            ret.push(key)
          }
          return ret
        }
      }
    }
  }
}
function getCallback() {
  for(var i=0;i<arguments.length;i++) {
    if(arguments[i] instanceof Function){
      return arguments[i]
    }
  }
  // if (arg1 && typeof arg1 === 'function') {
  //   return arg1
  // }
  // if (arg2 && typeof arg2 === 'function') {
  //   return arg2
  // }
  // if (arg3 && typeof arg3 === 'function') {
  //   return arg3
  // }
}
export function query(arg0, arg1, arg2, arg3) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/queryOne')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1, arg2)
  var fields = getFields(params, arg0, arg1, arg2)
  var callback = getCallback(arg0, arg1, arg2, arg3)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  if (fields) {
    data['fields'] = fields
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[params|fields],[callback]
export function queryOne(arg0, arg1, arg2, arg3) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/queryOne')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1, arg2)
  var fields = getFields(params, arg0, arg1, arg2)
  var callback = getCallback(arg0, arg1, arg2, arg3)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  if (fields) {
    data['fields'] = fields
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[params|fields],[callback]
export function queryAll(arg0, arg1, arg2, arg3) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/queryAll')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1, arg2)
  var fields = getFields(params, arg0, arg1, arg2)
  var callback = getCallback(arg0, arg1, arg2, arg3)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  if (fields) {
    data['fields'] = fields
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[params|fields],[callback]
export function queryPage(arg0, arg1, arg2, arg3) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/queryPage')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1, arg2)
  var fields = getFields(params, arg0, arg1, arg2)
  var callback = getCallback(arg0, arg1, arg2, arg3)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  if (fields) {
    data['fields'] = fields
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[params|fields],[callback]
export function submit(arg0, arg1, arg2) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/submit')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1)
  var callback = getCallback(arg0, arg1, arg2)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[params|fields],[callback]
export function invalid(arg0, arg1, arg2) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/invalid')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1)
  var callback = getCallback(arg0, arg1, arg2)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[callback]
export function update(arg0, arg1, arg2) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/update')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1)
  var callback = getCallback(arg0, arg1, arg2)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[callback]
export function add(arg0, arg1, arg2) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/add')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1)
  var callback = getCallback(arg0, arg1, arg2)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[params|fields],[callback]
export function plus(arg0, arg1, arg2, arg3) {
  var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/plus')
  var entity = getEntity(arg0)
  var params = getParams(arg0, arg1, arg2)
  var fields = getFields(params, arg0, arg1, arg2)
  var callback = getCallback(arg0, arg1, arg2, arg3)
  var data = {}
  if (params) {
    for (var key in params) {
      data[key] = params[key]
    }
  }
  if (entity) {
    data['entity'] = entity
  }
  if (fields) {
    data['fields'] = fields
  }
  ajaxJson(url, data, callback)
}
// url|entity,[params|fields],[callback]
export function upload(arg0, arg1, arg2, arg3) {
  // var url = getUrl(arg0, '/api/'+arg0.toLowerCase()+'/upload')
  var url = getUrl(arg0, '/api/upload')
  // var entity = getEntity(arg0)
  // var params = getParams(arg0, arg1)
  // var callback = getCallback(arg0, arg1, arg2)
  // var data = {}
  // if (params) {
  //     for (var key in params) {
  //         data[key] = params[key]
  //     }
  // }
  // if (entity) {
  //     data['entity'] = entity
  // }
  ajaxUpload(url, arg1, arg2, arg3)
}

// 导出常用函数

/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 */
 export function awaitForm(url, params = {}, headers = {'Content-Type':'application/x-www-form-urlencoded'}) {
  try{
    return axios({
      method: 'post',
      url,
      params,
      headers,
    })
  } catch(err){
    return {}
  }
}

/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 */
export function awaitJson(url, params = {}, headers = {'Content-Type':'application/x-www-form-urlencoded'}) {
  try{
    return axios({
      method: 'post',
      url,
      params,
      headers,
    })
  } catch(err){
    return {}
  }
}
